module.exports = __webpack_public_path__ + "img/strip-collage.667d764e.png";